module.exports = __webpack_public_path__ + "static/media/nextterm-icon.187c9a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/nextterm-icon.svg
// module id = 2876
// module chunks = 0